<template>
    <div>
        <section class="section has-background-pale-grey" v-if="showTitles">
            <div class="container">
                <p
                    class="
                        title
                        has-text-centered has-text-weight-normal has-text-grey
                        is-size-4
                    "
                >
                    {{ $t('Creation.collection_type') }}
                </p>
            </div>
        </section>

        <div class="columns is-multiline is-centered">
            <div
                v-for="type in collectionTypes"
                :key="type.name"
                class="column is-4-desktop is-6-tablet"
            >
                <article
                    :class="{ disabled: !type.free && !canBeCreated(type) }"
                    class="card has-background-light-grey"
                >
                    <div class="card-image px-0 py-2">
                        <figure class="image is-2by1">
                            <img
                                :src="type.image"
                                :alt="$t(`Creation.${type.name}.title`)"
                            />
                        </figure>
                    </div>
                    <div class="card-content pt-0">
                        <div class="has-text-centered pb-4">
                            <p
                                v-t="`Creation.${type.name}.title`"
                                class="
                                    is-size-6 is-uppercase
                                    has-text-weight-bold
                                    pb-2
                                "
                            />
                            <p
                                v-html="$t(`Creation.${type.name}.description`)"
                                class="is-size-6 has-text-centered"
                            />
                        </div>

                        <div v-if="!type.free && !canBeCreated(type)">
                            <button
                                v-if="showButtons"
                                v-t="'creation_coming_soon'"
                                :disabled="!type.free && !canBeCreated(type)"
                                class="
                                    is-small
                                    button
                                    is-rounded is-primary is-size-6
                                "
                                @click="$emit('click', type)"
                            />
                        </div>
                        <div v-else>
                            <button
                                v-if="showButtons"
                                v-t="'creation_select_button'"
                                class="
                                    is-small
                                    button
                                    is-rounded is-primary is-size-6
                                "
                                @click="$emit('click', type)"
                            />
                        </div>
                    </div>
                </article>
            </div>
        </div>

        <section class="section" v-if="showTitles">
            <div class="container">
                <p
                    class="
                        has-text-centered has-text-weight-normal has-text-grey
                        is-size-4
                    "
                >
                    {{ $t('Creation.game_type') }}
                </p>
            </div>
        </section>

        <div class="columns is-multiline is-centered">
            <div
                v-for="type in gameTypes"
                :key="type.name"
                class="column is-4-desktop is-6-tablet"
            >
                <article
                    :class="{ disabled: !type.free && !canBeCreated(type) }"
                    class="card has-background-light-grey"
                >
                    <div class="card-image px-0 py-2">
                        <figure class="image is-2by1">
                            <img
                                :src="type.image"
                                :alt="$t(`Creation.${type.name}.title`)"
                            />
                        </figure>
                    </div>
                    <div class="card-content pt-0">
                        <div class="has-text-centered pb-4">
                            <p
                                v-t="`Creation.${type.name}.title`"
                                class="
                                    is-size-6 is-uppercase
                                    has-text-weight-bold
                                    pb-2
                                "
                            />
                            <p
                                v-html="$t(`Creation.${type.name}.description`)"
                                class="is-size-6 has-text-centered"
                            />
                        </div>
                        <div v-if="!type.free && !canBeCreated(type)">
                            <button
                                v-if="showButtons"
                                v-t="'creation_coming_soon'"
                                :disabled="!type.free && !canBeCreated(type)"
                                class="
                                    is-small
                                    button
                                    is-rounded is-primary is-size-6
                                "
                                @click="$emit('click', type)"
                            />
                        </div>
                        <div v-else>
                            <button
                                v-if="showButtons"
                                v-t="'creation_select_button'"
                                class="
                                    is-small
                                    button
                                    is-rounded is-primary is-size-6
                                "
                                @click="$emit('click', type)"
                            />
                        </div>
                    </div>
                </article>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            collectionTypes: [
                {
                    name: 'collection',
                    type: 'collection',
                    image: require('@/assets/images/wall@3x.png'),
                    free: true,
                },
                /*{
                    name: 'timemachine',
                    image: require('@/assets/images/timemachine@3x.png'),
                },*/
                {
                    name: 'contentmap',
                    type: 'collection',
                    image: require('@/assets/images/contentmap@3x.png'),
                    mode: 'map',
                    free: true,
                },
                /*{
                    name: 'storytelling',
                    image: require('@/assets/images/storytelling@3x.png'),
                    type: 'storytelling',
                    free: true,
                },*/
            ],
            gameTypes: [
                {
                    name: 'trivial',
                    type: 'trivial',
                    image: require('@/assets/images/trivial@3x.png'),
                    free: true,
                },
                {
                    name: 'trivialgeo',
                    type: 'trivial',
                    image: require('@/assets/images/trivialgeo@3x.png'),
                    mode: 'map',
                    free: true,
                },
                {
                    name: 'treasurehunt',
                    type: 'treasurehunt',
                    image: require('@/assets/images/treasurehunt_color.png'),
                    free: true,
                },
            ],
        };
    },
    computed: {
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
    },
    methods: {
        canBeCreated(project) {
            if (this.isAdmin) {
                return true;
            }
        },
    },
    props: {
        showTitles: {
            type: Boolean,
            default: true,
        },
        showButtons: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style scoped>
.card {
    margin: auto;
}
.card.disabled {
    opacity: 0.4;
}
.card-image {
    padding: 2rem;
}
img {
    object-fit: contain;
}
</style>
